export const SHIFT_DATE_RANGE = "shift_date_range";
export const SHIFT_DOCTORS = "shift_doctors";
export const SHIFT_TYPE = "shift_type";
export const SHIFT_CATEGORIES = "shift_categories";
export const SHIFT_PAYMENT_TYPE = "payment_type";
export const SHIFT_TOGGLE_IN_ON_TIME = "shift_toggle_in_on_time";
export const SHIFT_TOGGLE_OUT_ON_TIME = "shift_toggle_out_on_time";
export const SHIFT_GP = "shift_gp";
export const SHIFT_NON_GP_TIME_RANGE = "shift_non_gp_time_range";
export const SHIFT_NON_GP = "shift_non_gp";
export const SELECT_TYPE = "select_type";
export const ACTIVE_TYPE = "active_type";
export const DELETE_SHIFT_NON_GP_DAY_TIME_RANGE = "delete_shift_non_gp_day_time_range";
export const SUBMIT_FORM = "submit_form";
export const STATUS_DOCTOR_SHIFT_CREATE = "status_doctor_shift_create";
export const FETCH_ACTIVE_DOCTOR_SHIFTS = "fetch_active_doctor_shifts";
export const FETCH_ACTIVE_DOCTOR_SHIFTS_SUCCESS = "fetch_active_doctor_shifts_success";
export const SHIFT_GET_DATA = "shift_get_data";
export const SHIFT_GET_DATA_SUCCESS = "shift_get_data_success";
export const SHIFT_SEARCH_TYPE = "shift_search_type";
export const SHIFT_SEARCH_TYPE_DOCTOR = "shift_search_type_doctor";
export const SHIFT_SEARCH_TYPE_SHIFT_CATEGORY = "shift_search_type_shift_category";
export const SHIFT_SEARCH_TYPE_DATE_RANGE = "shift_search_type_date_range";
export const SHIFT_SEARCH_SUBMIT_STATUS = "shift_search_submit_status";
export const SHIFT_EDIT = "shift_edit";
export const SHIFT_EDIT_SUBMIT_FORM = "shift_edit_submit_form";
export const SHIFT_EDIT_SUCCESS = "shift_edit_success";
export const SHIFT_EDIT_STATUS = "shift_edit_status";
export const SHIFT_EDIT_DOCTOR_ID = "shift_edit_doctor_id";
export const SHIFT_EDIT_START_DATE = "shift_edit_start_date";
export const SHIFT_EDIT_END_DATE = "shift_edit_end_date";
export const SHIFT_EDIT_PAYMENT_TYPE = "shift_edit_payment_type";
export const SHIFT_EDIT_REMARK = "shift_edit_remark";
export const SHIFT_EDIT_AUTO_TOGGLE_IN_ON_THAT_TIME = "shift_edit_auto_toggle_in_on_that_time";
export const SHIFT_EDIT_AUTO_TOGGLE_OUT_ON_THAT_TIME = "shift_edit_auto_toggle_out_on_that_time";
export const SHIFT_EDIT_CATEGORY_ID = "shift_edit_category_id";
export const SHIFT_SET_IS_CHECKED = "shift_set_is_checked";
export const SUBMIT_BULK_DELETE = "submit_bulk_delete";
export const SHIFT_CHANGE_DIALOG_BOX = "shift_change_dialog_box";
export const SHIFT_SET_DELETE_ID = "shift_change_delete_id";
export const SUBMIT_DELETE = "submit_delete";
export const CLEAR_NEW_DOCTOR_SHIFT = "clear_new_doctor_shift";
